import { List, SimpleGrid } from '@chakra-ui/react';

import PostCardItemOutline from '@/components/Card/PostItemCardOutline';
import { NoEntries } from '@/components/NoEntries/NoEntries';

import RoutePath from '@/constants/route-path';
import { EventContent, StrapiDataObject } from '@/models/cms';

type EventsGridProps = {
    events: StrapiDataObject<EventContent>[];
};

function EventsGrid(props: EventsGridProps) {
    const { events } = props;

    return (
        <SimpleGrid as={List} rowGap={3}>
            {events.length > 0 ? (
                events.map((item, index) => (
                    <PostCardItemOutline
                        key={index}
                        title={item.attributes.title}
                        shortDescription={item.attributes.shortDescription || ''}
                        url={`${RoutePath.Events}/${item.attributes.slug}` || ''}
                        imageUrl={
                            item.attributes.image.data.attributes.formats?.medium?.url === undefined
                                ? item.attributes.image.data.attributes.url
                                : item.attributes.image.data.attributes.formats?.medium?.url
                        }
                        imageAlt={
                            item.attributes.image.data.attributes.alternativeText ||
                            item.attributes.title
                        }
                    />
                ))
            ) : (
                <NoEntries message="page.events.no-entries" />
            )}
        </SimpleGrid>
    );
}

export default EventsGrid;
